export default __webpack_public_path__ + "three-dots-small.a3b1ebb2ded0eaab.svg";